import { BaseViewStore } from 'core/stores';
import { action, observable } from 'mobx';
import { FacilityInventoryCalculationService } from "application/facility-order/services";

class FacilityOrderNewFlowInventoryCalculationProcessModalStore extends BaseViewStore {
	@observable accessor isLoading = false;
	constructor(rootStore, componentsProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.id = componentsProps.modalParams.data.id;
        this.modalParams = componentsProps.modalParams;
        this.setInventoryCompleted = componentsProps.modalParams.data.setInventoryCompleted;
        this.getInventoryCalculation = componentsProps.modalParams.data.getInventoryCalculation;
        this.facilityInventoryCalculationService = new FacilityInventoryCalculationService(rootStore.application.baasic.apiClient);
    }

	@action.bound
	async processInventory() {
		this.isLoading = true;
		try {
			await this.facilityInventoryCalculationService.newFlowProcess(this.id);
			this.rootStore.notificationStore.success('LIST_LAYOUT.SUCCESS_PROCESS');
		} catch (err) {
			await this.getInventoryCalculation();
			this.rootStore.notificationStore.error(err && err.data && err.data.errors ? err.data.errors : 'Error occurred while trying to process a Inventory Calculation.');
		}
		await this.setInventoryCompleted();
		this.modalParams.close()
		this.isLoading = false;
	}

}

export default FacilityOrderNewFlowInventoryCalculationProcessModalStore;